// src/lib/analytics/index.ts
/**
 * @fileoverview Public entry point for the analytics layer.
 * @description Import the typed event API and the registry from here:
 *
 * ```ts
 * import { track } from "~/lib/analytics"
 * track("resource_view", { resource_type: "calculator", resource_slug: "video-dropoff" })
 * ```
 *
 * This replaces the former `~/lib/analytics` "UnifiedAnalytics" singleton, which
 * was unused and would have double-counted Vercel events (it both mirrored via
 * gtag AND called Vercel directly). The single source of truth for naming and
 * fan-out is now `./registry`; see `docs/analytics/event-taxonomy.md`.
 */

export {
  track,
  sendEvent,
  pageview,
  GA_MEASUREMENT_ID,
  isGaAnalyticsTrackingAllowed,
  createEngagementTimer,
  createEngagementStopwatch,
  createEngagementTimers,
} from "~/lib/gtag"

export {
  isAnalyticsAllowed,
  notifyConsentChanged,
  invalidateConsentCache,
  CONSENT_STORAGE_KEY,
  CONSENT_CHANGED_EVENT,
} from "./consent"

export {
  recordAttributionTouch,
  recordAttributionTouchAsync,
  getAttributionProperties,
  ATTRIBUTION_STORAGE_KEY,
  ATTRIBUTION_NAV_KEY,
} from "./attribution"

export type { AttributionProps } from "./attribution"

export {
  EVENT_REGISTRY,
  getEventSpec,
  vercelEventFor,
  categoryFor,
  isConversionEvent,
  isRegisteredEvent,
} from "./registry"

export type {
  AnalyticsEventName,
  AnalyticsEventParams,
  EventCategory,
  EventSpec,
  EventPropValue,
  ResourceType,
  InteractionType,
  Outcome,
  StorefrontProduct,
  ResourceParams,
  RequestAccessStepParams,
  AttributionParams,
} from "./registry"
